// import package
import React, { Component } from "react";
import { Modal, Button } from 'react-bootstrap';

// import action
import { EditOfferTimer, rejectCoinWithdraw } from '../../actions/walletAction';

// import lib
import { toastAlert } from '../../lib/toastAlert';

class TimeEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            count: 1,
            initialized: false, // to avoid resetting on every update
        };
    }

    componentDidUpdate(prevProps) {
        const { isShow, records } = this.props;
        console.log("records to update timerrr",records)
        // If modal just opened & timer is available, set initial count
        if (isShow && !this.state.initialized && records?.offertimelimit) {
            this.setState({
                count: Number(records.offertimelimit),
                initialized: true,
            });
        }

        // Reset state when modal closes
        if (!isShow && prevProps.isShow !== isShow) {
            this.setState({ initialized: false });
        }
    }

    handleChange = (e) => {
        let value = parseInt(e.target.value);
        if (isNaN(value) || value < 1) value = 1;
        this.setState({ count: value });
    }

    increment = () => {
        this.setState((prevState) => ({ count: prevState.count + 1 }));
    }

    decrement = () => {
        this.setState((prevState) => ({
            count: prevState.count > 1 ? prevState.count - 1 : 1,
        }));
    }

    SubmitTime = async () => {
        const { records, fetchData,getData } = this.props;
        const { count } = this.state;
        this.setState({ loader: true });
        try {
            console.log("Dei varan data",records,count)
            const { status, loading, message } = await EditOfferTimer({_id:records._id,count:count});
            console.log("Statusssssssssssss",status,loading,message)
            this.setState({ loader: loading });
            if (status === 'success') {
                // fetchData(); 
                window.location.reload();
                this.handleClose();
                toastAlert('success', message, 'coinwithdraw');
            } else {
                toastAlert('error', message, 'coinwithdraw');
            }
        } catch (err) {
            console.log("ERRORRORORORROROROROR",err);
         }
    }

    // confirmSubmit = async () => {
    //     const { record, fetchData } = this.props;
    //     const { count } = this.state;

    //     this.setState({ loader: true });
    //     try {
    //         const { status, loading, message } = await approveCoinWithdraw(record._id);
    //         this.setState({ loader: loading });

    //         if (status === 'success') {
    //             fetchData();
    //             this.handleClose();
    //             toastAlert('success', message, 'coinwithdraw');
    //         } else {
    //             toastAlert('error', message, 'coinwithdraw');
    //         }
    //     } catch (err) { }
    // }

    handleClose = () => {
        const { onHide } = this.props;
        onHide();
        this.setState({ count: 1, initialized: false }); // reset count when closing
    }

    render() {
        const { isShow } = this.props;
        const { loader, count } = this.state;

        return (
            <Modal
                show={isShow}
                onHide={this.handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Time</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="popUpSpace">
                        <div className="ed-input__actions mt-4">
                            <button onClick={this.decrement}>-</button>
                            <input
                                type="number"
                                disabled
                                value={count}
                                onChange={this.handleChange}
                            />
                            <button onClick={this.increment}>+</button>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        onClick={this.handleClose}
                        variant="secondary"
                        disabled={loader}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={this.SubmitTime}
                        variant="success"
                        disabled={loader}
                    >
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default TimeEdit;
